import React, { useEffect, useState } from 'react';

import { ExpandCollapse, Typography } from '@telus-uds/components-web';
import moment from 'moment-timezone';

import PropTypes from 'prop-types';

import request from '../../../../../utils/request';
import {
  OrderHistoryMain,
  OrderHistoryDataMain,
  OrderHistoryTimestamp,
  OrderHistoryAction
} from '../css';
import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const OrderHistory = ({ orderData }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { orderHistory }
  } = localizedStrings;
  const [orderHistoryData, setOrderHistoryData] = useState();

  useEffect(() => {
    const { id } = orderData;
    request.get(`/orders/${id}/order-history`).then(result => {
      setOrderHistoryData(result.data);
    });
  }, []);

  const getLocalFormattedTime = (date, time) => {
    const localZone = moment.tz.guess();
    const format = 'hh:mm A';
    const dateTime = `${date} ${time}`;

    return `${moment
      .utc(dateTime)
      .local()
      .format(format)} ${moment.tz.zone(localZone).abbr(360)}`;
  };

  return (
    <div className="view-order-summary">
      <Typography heading="h3" variant={{ size: 'h3' }} block>{orderHistory}</Typography>
      <OrderHistoryMain>
        {orderHistoryData &&
          Object.keys(orderHistoryData).map(date => {
            return (
              <ExpandCollapse key={date} initialOpen={[]} tag="h2" topDivider={false}>
                {(expandProps) => (
                  <ExpandCollapse.Panel
                    {...expandProps}
                    panelId={date}
                    control={<Typography variant={{ bold: true }}>{date}</Typography>}
                  >
                    {orderHistoryData[date].map(data => (
                      <OrderHistoryDataMain key={`${date}-${data.timeStamp}`}>
                        <OrderHistoryTimestamp>
                          {getLocalFormattedTime(date, data.timeStamp)}
                        </OrderHistoryTimestamp>
                        <OrderHistoryAction>{`${data.action} by ${data.user}`}</OrderHistoryAction>
                      </OrderHistoryDataMain>
                    ))}
                  </ExpandCollapse.Panel>
                )}
              </ExpandCollapse>
            );
          })}
      </OrderHistoryMain>
    </div>
  );
};

OrderHistory.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired
};

export default OrderHistory;
